import React from "react";


const WhiteBox = ({children}) => {
	return (
		<div className={"drafts-empty-list"}>{children}</div>
	);
};

export default WhiteBox